// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__Ddt-o","box":"HomePage_box__PraeL","icon":"HomePage_icon__wY2oR","button":"HomePage_button__OBaB8"};